import { render, staticRenderFns } from "./DocumentValidatorPage.vue?vue&type=template&id=0105a284&scoped=true"
import script from "./DocumentValidatorPage.vue?vue&type=script&lang=js"
export * from "./DocumentValidatorPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentValidatorPage.vue?vue&type=style&index=0&id=0105a284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105a284",
  null
  
)

export default component.exports